export default __webpack_public_path__ + "static/media/linkedin.91da88e8.svg";